import { render } from "./healthIndivid.vue?vue&type=template&id=8c7e8fa4&scoped=true"
import script from "./healthIndivid.vue?vue&type=script&lang=js"
export * from "./healthIndivid.vue?vue&type=script&lang=js"

import "./healthIndivid.vue?vue&type=style&index=0&id=8c7e8fa4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7e8fa4"]])

export default __exports__